import { Outlet } from 'react-router'

const LeadsMainLayout = () => {
  return (
    <Outlet />
  )
}

export default LeadsMainLayout